import { BridgeReady } from "./constants";
var is = function is(type) {
  return function (obj) {
    return toString.call(obj) === "[object ".concat(type, "]");
  };
};
// eslint-disable-next-line @typescript-eslint/ban-types
export var isFunction = is('Function');
export var isNaN = function isNaN(num) {
  return parseInt('' + num, 10).toString() === 'NaN';
};
export var isString = is('String');
export var isEmptyObject = function isEmptyObject(obj) {
  for (var name_1 in obj) {
    return false;
  }
  return true;
};
export function safeJSONStringify(value) {
  var res;
  try {
    res = JSON.stringify(value);
  } catch (err) {
    res = value;
  }
  return res;
}
export function safeJSONParse(str, dft) {
  if (!str) {
    return dft;
  }
  var res;
  try {
    res = JSON.parse(str);
  } catch (err) {
    res = dft;
  }
  return res;
}
export var callbackFn = function callbackFn(res, callback) {
  var _a = callback || {},
    success = _a.success,
    fail = _a.fail,
    complete = _a.complete;
  // @ts-ignore
  if (res.error && isFunction(fail)) {
    // @ts-ignore
    fail(res);
  } else {
    isFunction(success) && success(res);
  }
  // @ts-ignore
  isFunction(complete) && complete(res);
};
export var loadAppxBridge = function loadAppxBridge(cb) {
  try {
    // @ts-ignore
    if (window.my) {
      cb && cb(BridgeReady.READY);
      return;
    }
    var script_1 = document.createElement('script');
    script_1.src = 'https://appx/web-view.min.js';
    script_1.onload = function onload() {
      var readyState = script_1['readyState'];
      if (typeof readyState === 'undefined' || /^(loaded|complete)$/.test(readyState)) {
        script_1.onload = null;
        cb && cb(BridgeReady.LOADED);
      }
    };
    var head = document.getElementsByTagName('head')[0] || document.body;
    head.appendChild(script_1);
  } catch (e) {
    cb && cb(null);
  }
};
export var alipayJSBridgeReady = function alipayJSBridgeReady(cb) {
  var env = window;
  if (env.AlipayJSBridge) return cb();
  document.addEventListener('AlipayJSBridgeReady', function () {
    return cb();
  }, false);
};
export var upFirst = function upFirst(word) {
  return word.replace(/^([a-z])/, function (_, __) {
    return __.toUpperCase();
  });
};
export var isIOS = function () {
  try {
    return /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream;
  } catch (_a) {
    return false;
  }
}();